/**
 * Created by draplater on 17-7-10.
 */


export const baseDir = "./";

export const colors = [
    "#FFFF99", "#CCFFFF",
    "#FFCCCC", "#CCCC99",
    "#99CC99", "#FFCC33",
    "#CCFF99", "#CCCCFF",
    "#FFCC99", "#FF9966"
];

export async function getJson(url:string) {
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils.ts